<template>

  <div id="main"
       class="wh1200" style="    margin-top: 41px;">
    <div class="sign_top">
      <a href="javascript:;"
         @click="blank"
         class="go_home"><img src="../static/fanhui.png"
             alt="">返回</a>
      <div class="sign_top_title">用户注册</div>
      <div class="sign_top_text">中国林业产业官方平台</div>
      <div class="zhuce_buzhou">
        <div class="line_box">
          <div class="yuan l_yuan on"></div>
          <div class="yuan r_yuan"></div>
        </div>
        <div class="text on">1、填写信息</div>
        <div class="text text_r">2、完成注册</div>
        <div class="clear"></div>
      </div>
    </div>
    <div class="zhuce_content">
      <div class="zhuce_form">
        <div class="input_box">
          <div class="name">请填写用户名</div>
          <input type="text"
                 class="input"
				 :class='{Validform_error:name}'
                 v-model="sendFrom.official_name"
                 :style="name==true?'border: 1px solid #cc0001;':''"
                 placeholder="6~20个字符，支持字母数字组合"
                 maxlength="20"
                 datatype="*6-20"
                 nullmsg="用户名不可为空"
                 errormsg="6~20个字符，第一位必须为字母">
                  <span class="input-tip" style="display: block;
    margin-top: 10px;
    font-size: 10px;" v-show="name">{{nameTip}}</span>
        </div>
        <div class="input_box">
          <div class="name">请填写您的手机号码</div>
          <input type="number"
                 class="input"
                  :style="phone==true?'border: 1px solid #cc0001;':''"
                  v-model="sendFrom.official_phone"
                 placeholder="请填写您的手机号码"
                 datatype="m"
                 oninput="value=this.value.replace(/\D+/g,'');if(value.length>11)value=value.slice(0,11)"
                 nullmsg="手机号码不可为空"
                 errormsg="手机号码格式不正确">
                 <span class="input-tip" style="display: block;
    margin-top: 10px;
    font-size: 10px;
    " v-show="phone">手机号码格式不正确</span>
        </div>
        <div class="input_box"
             style="margin-bottom: 10px;">
          <div class="name">请设置密码</div>
          <input type="password"
                 name="userpassword"
                   v-model="sendFrom.official_pwd"
                   :style="pwd==true?'border: 1px solid #cc0001;':''"
                 class="input"
				 :class='{Validform_error:pwd}'
                 placeholder="6~20个字符，支持字母数字组合"
                 maxlength="20"
                 datatype="*6-20"
                 nullmsg="密码不可为空"
                 errormsg="6~20个字符，必须为字母数字组合">
        </div>
        <div class="input_box" style="">
          <input type="password"
                 name="userpassword2"
                 recheck="userpassword"
                 class="input"
				 :class='{Validform_error:pwd}'
                  v-model="official_pwd"
                  :style="pwd==true?'border: 1px solid #cc0001;':''"
                 placeholder="请再次输入密码"
                 maxlength="20"
                 datatype="*6-20"
                 nullmsg="密码不可为空"
                 errormsg="两次密码不一致">
                 <span class="input-tip" style="display: block;
    margin-top: 10px;
    font-size: 10px;
   " v-show="pwd">两次密码不一致或为空</span>
        </div>

        <div class="input_box">
          <div class="name">请填写验证码</div>
          <div class="yanzhengma_box">
            <input type="text"
                   class="input padd_ri"
				   :class='{Validform_error:verifyCoder}'
                   v-model="sendFrom.verifyCoder"
                   placeholder="请填写验证码"
                   onkeyup="value=value.replace(/[^\w\.\/]/ig,'')"
                   maxlength="6"
                   datatype="*6-6"
                   nullmsg="验证码不可为空"
                     :style="verifyCoder==true?'border: 1px solid #cc0001;':''"
                   errormsg="验证码不正确">

            <a href="javascript:;"
               class="yanzhengma" ref="yanzhengma"><img :src="images"  @click="appImage"
                   alt=""></a>
          </div>
          <span  class="input-tip"  style="display: block;
    margin-top: 10px;
    font-size: 10px;
" v-show="verifyCoder">{{verifyCoderTip}}</span>

        </div>

        <button class="submit"
                @click="sendClick">提交注册</button>
      </div>
    </div>
  </div>

</template>

<script>
import user from '@/api/modules/user'
import axios from 'axios'
export default {
  data () {
    return {
      sendFrom: {

        'official_name': '',
        'official_pwd': '',
        'official_phone': '',
        'coderToken': '',
        'verifyCoder': ''
      },
      official_pwd: '',
      images: '',
      name: false,
      nameTip: '用户名不可为空',
      phone: false,
      pwd: false,
      verifyCoder: false,
      verifyCoderTip: '验证码不可为空'
    }
  },
  created () {
    this.init()
  },
  methods: {
    blank () {
      this.$router.push({ path: '/' })
    },
    sendClick () {
      //
      // console.log(this.sendFrom)
      if (this.sendFrom.official_name == '') {
        this.name = true
        this.nameTip = '用户名不可为空'
      } else {
        this.name = false
        if (!(/^1[3456789]\d{9}$/.test(this.sendFrom.official_phone))) {
          this.phone = true
        } else {
          this.phone = false
          if (this.sendFrom.official_pwd != this.official_pwd || this.sendFrom.official_pwd == '' || this.official_pwd == '') {
            this.pwd = true
          } else {
            this.pwd = false
            if (this.sendFrom.verifyCoder == '') {
              this.verifyCoderTip = '验证码不可为空'
              this.verifyCoder = true
            } else {
              this.verifyCoder = false
              this.savInfo()
            }
          }
        }
      }

      // this.$router.push({ path: '/registerend' })
    },

    savInfo () {
      axios({
        method: 'post',
        url: user.save,
        data: this.sendFrom
      }).then(res => {
        console.log(res.data)
        if (res.data.status == 3) {
          this.verifyCoderTip = res.data.msg
          this.verifyCoder = true
        } else {
          if (res.data.status == 1) {
            this.$router.push({ path: '/registerend' })
          }
          if (res.data.status == 2) {
            this.name = true
            this.nameTip = '用户名不可使用'
          }
        }
      })
    },
    init () {
      axios.get(user.coderImg + new Date().getTime(), { responseType: 'blob' }).then(res => {
        this.images = window.URL.createObjectURL(res.data)
        this.sendFrom.coderToken = res.headers.token
      })
    },
    appImage () {
      let image = new Image()
      image.style.width = '109px'
      image.style.height = '38px'
      axios.get(user.coderImg + new Date().getTime(), { responseType: 'blob' }).then(res => {
        image.src = window.URL.createObjectURL(res.data)
        this.sendFrom.coderToken = res.headers.token
      })

      let setImage = document.querySelector('.yanzhengma')
      this.$refs.yanzhengma.innerHTML = ''
      setImage.appendChild(image)
      setImage.addEventListener('click', this.appImage)
    }

  }
}
</script>

<style scoped>
.wh1200 {
  max-width: 1200px;
  margin: 0 auto;
}
a:hover{
cursor:pointer;
}
.sign_top {
  padding: 25px 0px;
  background: url(../static/sign_bg.png) center center no-repeat;
  position: relative;
  text-align: center;
}
.sign_top .go_home {
  font-size: 18px;
  color: #0658a4;
  position: absolute;
  top: 50px;
  left: 30px;
  -webkit-transition: all 0.2s ease-out;
  -khtml-transition: all 0.2s ease-out;
  -moz-transition: all 0.2s ease-out;
  -o-transition: all 0.2s ease-out;
  transition: all 0.2s ease-out;
}
.sign_top .go_home:hover {
  opacity: 0.6;
}
.sign_top .go_home img {
  position: relative;
  width: 10px;
  top: 1px;
  margin-right: 10px;
}
.sign_top_title {
  font-size: 36px;
  color: #333333;
  font-weight: bold;
}
.sign_top_text {
  font-size: 18px;
  color: #333333;
  margin-top: 14px;
}
.navigation {
  display: none;
}
.header_top {
  border-bottom: 4px solid #cc0001;
}
.sign_content {
  margin-top: 20px;
}
.sign_content .left_img {
  float: left;
  width: 60%;
  height: 400px;
  background-size: cover !important;
}
.sign_content .right_form {
  float: left;
  width: 25%;
  margin-left: 90px;
}
.form_title {
  font-size: 20px;
  color: #333333;
  font-weight: bold;
  margin-bottom: 25px;
}
.right_form {
  margin-top: 30px;
}
.input_box {
  position: relative;

  margin-top: 10px;
}
.input_box .input {
  width: 100%;
  box-sizing: border-box;
  height: 40px;
  border: 1px solid #ddd;
  border-radius: 3px;
  padding-left: 40px;
  padding-right: 15px;
  -webkit-transition: all 0.2s ease-out;
  -khtml-transition: all 0.2s ease-out;
  -moz-transition: all 0.2s ease-out;
  -o-transition: all 0.2s ease-out;
  transition: all 0.2s ease-out;
}
.input_box .input.Validform_error {
  border: 1px solid #cc0001;
}
.input_box .name {
  position: absolute;
  left: 0px;
  top: 0px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  width: 40px;
}
.Validform_checktip {
  display: none;
}
.input_box .input.padd_ri {
  padding-right: 118px;
}
.yanzhengma {
  position: absolute;
  right: 1px;
  top: 1px;
  height: 38px;
  width: 109px;
}
.yanzhengma img {
  width: 100%;
  height: 100%;
  display: block;
}
.right_form .submit {
  width: 100%;
  border: none;
  height: 50px;
  line-height: 50px;
  text-align: center;
  font-size: 16px;
  color: #fff;
  background: #cc0001;
  border-radius: 5px;
  -webkit-transition: all 0.2s ease-out;
  -khtml-transition: all 0.2s ease-out;
  -moz-transition: all 0.2s ease-out;
  -o-transition: all 0.2s ease-out;
  transition: all 0.2s ease-out;
  cursor: pointer;
  margin-top: 20px;
}
.right_form .submit:hover {
  background: #ef1e1f;
}
.zhuce_deng {
  overflow: hidden;
  font-size: 14px;
  color: #888888;
  padding-top: 15px;
  border-top: 1px solid #ddd;
  margin-top: 20px;
}
.zhuce_deng a {
  color: #0658a4;
  -webkit-transition: all 0.2s ease-out;
  -khtml-transition: all 0.2s ease-out;
  -moz-transition: all 0.2s ease-out;
  -o-transition: all 0.2s ease-out;
  transition: all 0.2s ease-out;
}
.zhuce_deng a:hover {
  color: rgba(6, 88, 164, 0.6);
}
.zhuce_deng .right_l {
  float: right;
}
.popup {
  position: fixed;
  width: 480px;
  height: 290px;
  background: #fff;
  top: 50%;
  margin-top: -145px;
  left: 50%;
  margin-left: -240px;
  -moz-box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.2);
  -webkit-box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.2);
  box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.2);
  text-align: center;
  z-index: 20;
  box-sizing: border-box;
  padding-top: 45px;
}
.close_popup {
  position: absolute;
  top: 10px;
  right: 10px;
  cursor: pointer;
  width: 30px;
  height: 30px;
  background: url(../static/close_popup.png) center center no-repeat;
}
.popup_text {
  font-size: 18px;
  color: #333333;
  line-height: 37px;
  margin-top: 10px;
}
.popup a {
  width: 198px;
  height: 48px;
  line-height: 48px;
  text-align: center;
  border-radius: 5px;
  border: 1px solid #ddd;
  font-size: 16px;
  color: #0658a4;
  display: inline-block;
  -webkit-transition: all 0.2s ease-out;
  -khtml-transition: all 0.2s ease-out;
  -moz-transition: all 0.2s ease-out;
  -o-transition: all 0.2s ease-out;
  transition: all 0.2s ease-out;
  margin-top: 30px;
}
.popup .popup_btn {
  background: #cc0001;
  color: #fff;
  border: none;
  width: 200px;
  height: 50px;
  line-height: 50px;
  margin-top: 40px;
}
.popup .popup_btn:hover {
  background: #ef1e1f;
  border: none;
}
.popup a:hover {
  border: 1px solid #0658a4;
}
.mima_box {
  width: 298px;
  height: 38px;
  line-height: 38px;
  text-align: center;
  border-radius: 5px;
  border: 1px solid #ddd;
  font-size: 16px;
  color: #cc0001;
  display: inline-block;
  margin-top: 10px;
  font-weight: bold;
}
.zhuce_form .Validform_error {
  display: block;
}
.line_box {
  width: 240px;
  margin: 0 auto;
  margin-top: 30px;
  height: 4px;
  background: #ddd;
  position: relative;
}
.line_box.line_box02:after {
  width: 100%;
}
.line_box:after {
  content: "";
  display: block;
  position: absolute;
  width: 50%;
  height: 4px;
  background: #cc0001;
  left: 0px;
  top: 0px;
}
.line_box .yuan {
  width: 14px;
  height: 14px;
  border-radius: 50%;
  border: 1px solid #ddd;
  position: absolute;
  top: -6px;
  background: #fff;
  z-index: 10;
}
.line_box .yuan.on:after {
  content: "";
  display: block;
  position: absolute;
  width: 10px;
  height: 10px;
  background: #cc0001;
  border-radius: 50%;
  left: 2px;
  top: 2px;
}
.line_box .l_yuan {
  left: -6px;
}
.line_box .r_yuan {
  right: -6px;
}
.zhuce_buzhou .text {
  float: left;
  font-size: 14px;
  color: #888888;
  margin-top: 15px;
}
.zhuce_buzhou .text.on {
  color: #cc0001;
}
.zhuce_buzhou .text.text_r {
  float: right;
}
.zhuce_buzhou {
  width: 320px;
  margin: 0px auto;
}
.zhuce_form {
  max-width: 300px;
  margin: 0px auto;
}
.zhuce_form .input_box {
  margin-bottom: 20px;
  position: relative;
}
.zhuce_form .input_box .name {
  position: relative;
  width: auto;
  height: auto;
  line-height: normal;
  text-align: left;
  font-size: 16px;
  color: #333333;
  margin-bottom: 10px;
}
.zhuce_form .input_box .input {
  padding: 0px 15px;
}
.zhuce_form .yanzhengma {
  top: auto;
  bottom: 1px;
}
.zhuce_form .Validform_checktip {
  display: block;
}
.zhuce_form .Validform_wrong {
  white-space: nowrap;
  position: absolute;
  left: 320px;
  bottom: 0px;
  height: 40px;
  line-height: 40px;
  background: #eb3e14;
  border-radius: 2px;
  font-size: 14px;
  color: #fff;
  padding: 0px 15px;
}
.zhuce_form .Validform_wrong:after {
  content: "";
  display: block;
  width: 3px;
  height: 6px;
  position: absolute;
  top: 50%;
  margin-top: -3px;
  left: -3px;
  background: url(../static/wrong_sanjiao.png) center center no-repeat;
}
.zhuce_form .Validform_right {
  display: none;
}
.zhuce_form .submit {
  width: 100%;
  border: none;
  height: 50px;
  line-height: 50px;
  text-align: center;
  font-size: 16px;
  color: #fff;
  background: #cc0001;
  border-radius: 5px;
  -webkit-transition: all 0.2s ease-out;
  -khtml-transition: all 0.2s ease-out;
  -moz-transition: all 0.2s ease-out;
  -o-transition: all 0.2s ease-out;
  transition: all 0.2s ease-out;
  cursor: pointer;
  margin-top: 20px;
}
.zhuce_form .submit:hover {
  background: #ef1e1f;
}
.zhuce_over_top {
  text-align: center;
}
.zhuce_content {
  max-width: 800px;
  margin: 0px auto;
  margin-top: 40px;
}
.zhuce_over_text {
  font-size: 18px;
  color: #cc0001;
  margin-top: 15px;
}
.zhuce_btn_box {
  overflow: hidden;
  text-align: center;
  margin-top: 40px;
  font-size: 0px;
}
.zhuce_btn_box a {
  display: inline-block;
  width: 198px;
  height: 48px;
  line-height: 48px;
  text-align: center;
  border-radius: 5px;
  border: 1px solid #ddd;
  font-size: 16px;
  color: #0658a4;
  display: inline-block;
  -webkit-transition: all 0.2s ease-out;
  -khtml-transition: all 0.2s ease-out;
  -moz-transition: all 0.2s ease-out;
  -o-transition: all 0.2s ease-out;
  transition: all 0.2s ease-out;
  margin: 0px 10px;
}
.zhuce_btn_box a:hover {
  border: 1px solid #0658a4;
}
.zhuce_btn_box a.red {
  background: #cc0001;
  color: #fff;
  border: none;
  height: 50px;
  line-height: 50px;
}
.zhuce_btn_box a.red:hover {
  background: #ef1e1f;
}
.input-tip{
    white-space: nowrap;
    position: absolute;
    left: 320px;
    bottom: 0px;
    height: 40px;
    line-height: 40px;
    background: #eb3e14;
    border-radius: 2px;
    font-size: 14px;
    color: #fff;
    padding: 0px 15px;
    color: #fff;
}
.input-tip::after{
    content: '';
    display: block;
    width: 3px;
    height: 6px;
    position: absolute;
    top: 50%;
    margin-top: -3px;
    left: -3px;
    background: url(../static/wrong_sanjiao.png) center center no-repeat;
}
</style>



// WEBPACK FOOTER //
// src/pages/register.vue